import { jwtDecode } from 'jwt-decode';
import { makeAutoObservable } from 'mobx';
import { Storage } from '../../utils/Storage';
import Cookies from 'universal-cookie';

export type TokenData = {
  sub: string;
};

const cookies = new Cookies(null, {
  path: '/',
  secure: true,
  sameSite: 'strict',
});

export class TokenStore {
  private static _instance: TokenStore;
  private static storageKey = 'accesstoken';

  _token: string = '';
  _tokenData: TokenData = null;

  private constructor() {
    makeAutoObservable(this);
    const storedToken = cookies.get(TokenStore.storageKey);

    if (storedToken && storedToken !== '') {
      this._token = storedToken;
      this._tokenData = jwtDecode(this._token);
    } else {
      const localStorageToken = Storage.get(TokenStore.storageKey);
      if (localStorageToken && localStorageToken !== '') {
        this.setToken(localStorageToken);
        Storage.delete(TokenStore.storageKey);
      }
    }
  }

  public static instance(): TokenStore {
    if (!TokenStore._instance) {
      TokenStore._instance = new TokenStore();
    }
    return TokenStore._instance;
  }

  get hasToken(): boolean {
    return !!this.token && this.token != '';
  }

  get token(): string {
    return this._token;
  }

  get tokenData(): TokenData {
    return this._tokenData;
  }

  public setToken(newToken: string): void {
    this._token = newToken;

    cookies.set(TokenStore.storageKey, this.token);
    this._tokenData = jwtDecode(this.token);
  }

  public reset(): void {
    this._token = null;
    this._tokenData = null;
    cookies.remove(TokenStore.storageKey);
  }
}
